// src/pages/gears/Neo.js

import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import AffiliateAmazon from "../../components/affiliate/AffiliateAmazon";
import AffiliateEbay from "../../components/affiliate/AffiliateEbay";
import React, { useState } from "react";

// ⭐ IMPORT ONLY THE IMAGES YOU NEED
import droneImg from "./gearimages/gp9.jpg";

export default function GoPro9() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "10px" }}>
        <section className="gear-review">

          {/* ⭐ NEW GEAR LAYOUT */}
          <div className="gear-container">

            {/* LEFT COLUMN */}
            <div className="gear-left">
              <h1>GoPro Hero 9 Black</h1>

              <p>
                The GoPro Hero 9 Black introduced a major upgrade with its 23.6MP sensor,
                allowing 5K video recording and sharper 20MP photos. It also added a
                front‑facing color display, making it easier for vlogging, framing shots,
                and capturing yourself during action moments.
              </p>

              <p>
                With HyperSmooth 3.0 stabilization, improved battery life, and features like
                HindSight (which captures up to 30 seconds before you press record),
                the Hero 9 is built for creators who want flexibility, durability,
                and excellent image quality in any environment.
              </p>

              <div className="place-block">
                <ul>
                  <li>5K video at 30fps + 4K at 60fps</li>
                  <li>20MP photos with SuperPhoto + HDR</li>
                  <li>HyperSmooth 3.0 stabilization</li>
                  <li>Front‑facing color display for vlogging</li>
                  <li>TimeWarp 3.0 hyperlapse mode</li>
                  <li>Waterproof up to 10m (33 ft) without a case</li>
                  <li>Built‑in folding mounting fingers</li>
                  <li>HindSight (captures 30 seconds before pressing record)</li>
                  <li>Improved battery life vs Hero 8</li>
                </ul>
              </div>

              <AffiliateAmazon
                title="Check price on Amazon"
                link="https://amzn.to/3Oz65pn"
              />

              <AffiliateEbay
              title="Check price on eBay"
                link="https://ebay.us/cKG5pH"
              />
            </div>

            {/* RIGHT COLUMN */}
            <div className="gear-right">
              <img src={droneImg} alt="GoPro Hero 9 Black" />
            </div>

          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
